import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

const MUTATION = graphql(`
  mutation UpdateStripeAPIKey($id: String!, $input: UpdateStripeAPIKeyInput!) {
    updateStripeAPIKey(id: $id, input: $input) {
      id
      name
      secretKey
      publishableKey
    }
  }
`);

export default function useUpdateStripeApi() {
  return useMutation(MUTATION, { refetchQueries: ['StripeAPIKeys'] });
}
